/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import ValueHistoryComponent from '../value-history-component';
import IconButton from '../../../button/IconButton';
import UniversalTracker from '../../../../model/UniversalTracker';
import { useToggle } from '../../../../hooks/useToggle';
import { ExistingEvidenceFile } from '../../../survey/question/questionInterfaces';
import { UserMin } from '../../../../constants/users';

interface Props {
  utr: UniversalTracker;
  utrValueId: string;
  users?: UserMin[];
  documents?: ExistingEvidenceFile[];
}

export const ValueHistoryButton = ({ utr, utrValueId, users, documents }: Props) => {
  const [display, toggle] = useToggle(false);

  return (
    <>
      <IconButton
        tooltip='View provenance history'
        color='transparent'
        outline={false}
        onClick={toggle}
        icon='fal fa-clipboard-list text-ThemeAccentMedium'
      />
      <Modal className='modal-lg' isOpen={display} toggle={toggle} backdrop='static'>
        <ModalHeader toggle={toggle}>Provenance</ModalHeader>
        <ModalBody>
          <ValueHistoryComponent
            utr={utr}
            users={users}
            documents={documents}
            utrValueId={utrValueId}
            isVisible={display}
          />
        </ModalBody>
      </Modal>
    </>
  );
};
